'use strict';

export default {
  email: '^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,6}$',
  phone: '^\\+[0-9]{9,}$'
};



// WEBPACK FOOTER //
// ./app/src/constants/patterns.js